<section class="my-registration">
    <p class="text-title p-title">Danh sách đăng ký của bạn</p>   
    
    <div class="scrollable-table">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table [dataSource]="registrations" matSort #registrationsMatSort="matSort" (matSortChange)="handleSortChange($event)" class="mat-elevation-z8">
                 
            <ng-container matColumnDef="formName"  >
            <th mat-header-cell *matHeaderCellDef > Tên đăng ký </th>
            <td mat-cell *matCellDef="let registration"> {{registration.formName}} </td>
            </ng-container>
        
            <ng-container matColumnDef="formDescription">
            <th mat-header-cell *matHeaderCellDef > Mô tả đăng ký </th>
            <td mat-cell *matCellDef="let registration"> {{registration.formDescription}} </td>
            </ng-container>
        
               <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef > Ngày bắt đầu </th>
            <td mat-cell *matCellDef="let registration"> {{registration.startDate}} </td>
            </ng-container>
               <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef > Ngày kết thúc </th>
            <td mat-cell *matCellDef="let registration"> {{registration.endDate}} </td>
            </ng-container>
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef > Xem chi tiết  </th>
                <td mat-cell *matCellDef="let registration"> 
                    <a  href="javascript:void(0)"  (click)="myRegistrationDetail(registration.formId)" > <mat-icon class="text-black action-mat-icon">visibility</mat-icon></a> 
                 </td>
            </ng-container>
        
            <ng-container matColumnDef="noRecord">
            <td *matFooterCellDef [attr.colspan]="displayedColumns.length" mat-footer-cell >Không có dữ liệu để hiển thị.</td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        
            <tr mat-footer-row *matFooterRowDef="['noRecord']" [ngClass]="{'no-record-found':!(registrations!=null && registrations.data.length===0)}" ></tr>
        </table>
        <mat-paginator #registrationsPaginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" (page)="handlePageEvent($event)" showFirstLastButtons>
        </mat-paginator>      
    </div>

</section>

    
     
    
  
